
// SVG Icon: difference
export default { id: "terriajs-difference" };
export const id = "terriajs-difference";
export const name = "difference";
